import React from "react";
import { ProductCard } from "../components/products";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../reducks/products/operations";
import { fetchCategories } from "../reducks/categories/operations";
import { fetchShops } from "../reducks/shops/operations";
import { fetchMakers } from "../reducks/makers/operations";
import { getProducts } from "../reducks/products/selectors";
import { useEffect } from "react";
import { getSearchKeywords } from "../reducks/searchKeywords/selectors";
import { ScrollButton } from "../components/UIkit";
import { getUserRole } from "../reducks/users/selectors";
import { PERMISSIONS } from "../constants/permissions";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { updateSearchKeywordsAction } from "../reducks/searchKeywords/actions";

const ProductList = () => {
  const dispatch = useDispatch();

  const userRole = useSelector(getUserRole);
  // const selector = useSelector((state) => state);
  // const products = getProducts(selector);
  // const categories = getCategories(selector);
  const products = useSelector(getProducts);
  // const categories = useSelector(getCategories);
  //const shops = useSelector(getShops);
  const searchKeywords = useSelector(getSearchKeywords);

  //const query = selector.router.location.search;
  const query = useSelector((state) => state.router.location.search);
  const gender = /^\?gender=/.test(query) ? query.split("?gender=")[1] : "";
  const category = /^\?category=/.test(query)
    ? query.split("?category=")[1]
    : "";

  //商品の情報をリアルタイムに監視
  useEffect(() => {
    const productRef = collection(db, "products");
    const unsubscribe = onSnapshot(productRef, (snapshot) => {
      dispatch(fetchProducts(gender, category, searchKeywords));
    });
    // コンポーネントのアンマウント時にリスナーを解除
    return () => unsubscribe();
  }, [dispatch, query, category, searchKeywords, gender]);

  useEffect(() => {
    dispatch(fetchCategories());
  }, []);
  useEffect(() => {
    dispatch(fetchShops());
  }, []);
  useEffect(() => {
    dispatch(fetchMakers());
  }, []);
  useEffect(() => {
    return () => dispatch(updateSearchKeywordsAction(""));
  }, []);

  const isAdministrator =
    userRole === PERMISSIONS.ADMINISTRATOR ||
    userRole === PERMISSIONS.HUMAN_RESOURCE_USER;

  return (
    <section className="c-section-wrapin">
      <div className="p-grid__row">
        {products.length > 0 &&
          products.map((product) =>
            isAdministrator ||
            (!isAdministrator && product.display === "表示") ? (
              <ProductCard
                key={product.id}
                id={product.id}
                name={product.name}
                images={product.images}
                idin={product.idin}
                price={product.price}
                display={product.display}
              />
            ) : null
          )}
      </div>
      <ScrollButton />
    </section>
  );
};

export default ProductList;
